import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D315 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">
        You're viewing D315 - Network and Security - Foundations
      </h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 6.98 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            This course has more information than the world itself. Jokes aside,
            soak all this information in. It's actually fun to learn and not
            just a by-hearting type of course. It was really interesting to
            learn about the IT that goes behind computers and the internet. Of
            course, the WGU study material is lacking, so I only used this guide
            <a
              href="/C172 Study Guide(Feb 2021 Update) (2).docx"
              download="C172 Study Guide(Feb 2021 Update) (2).docx" 
            >
              {" "}
              (Download Here)
            </a>{" "}
            for this course. Know this document inside out.
          </p>
          <p>
            I'm really good at absorbing information in a short span of time, so
            I was able to get it done quickly, but take your own time. The guide
            I've linked is old but much better than the new ones you'll find on
            Reddit. Understand the OSI layers and the two types of OSI models
            thoroughly. Use YouTube for certain terms or ask ChatGPT to explain
            them at a high level. Once you understand it, it's really cool!
          </p>
          <p>
            After studying this guide, I did the quizzes on myquizzet.com and
            the PA. The OA was very similar to the PA for this one. Make sure
            you read the questions carefully on the OA—most of them have the
            answer hidden in there itself. If you understand the question really
            well, you know the answer. That’s the rule of thumb.
          </p>
          <p>
            Know the network commands, types of ethernet cables, and network
            topologies (super easy). Cloud computing questions were a little
            confusing between community clouds and hybrid clouds—understand the
            difference properly. Know the different types of malware attacks and
            what they target. The CIA triad is easy to understand, but the
            questions were tough to differentiate. That's something I lost
            points on, I'm sure.
          </p>
          <p>
            The PAPA model has been explained by this guy soooo well:{" "}
            <a href="https://www.youtube.com/watch?v=Utd_sn7EYts&ab_channel=DenAdams" rel="noreferrer" target="_blank">
              Den Adams on YouTube.
            </a>{" "}
            Use the Venn diagram to understand IDS vs. IPS. It's a super fun and
            easy course. It seems like a lot of information, but if you
            understand the basics, it's easy to answer the questions.
          </p>
          <p>
            Here's a guide I was making but never got to finish lol, but here it
            is:{" "}
            <a
              href="/D315 - Network & Security Foundations.docx"
              download="Network & Security Foundations.docx"
            >
              Download Notes
            </a>
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};

export default D315;
